<template>
    <div class="index-box">
        <van-nav-bar title="商家管理中心" />

        <div class="top">
            <div class="left"><img :src="imageuHost" alt="" /></div>
            <div class="right">
                <div class="r1">{{ userinfo.chargeName }}</div>
                <div class="r2">{{ userinfo.fullName }}</div>
                <div class="r3">入驻平台：{{ userinfo.deptName }}</div>
            </div>
        </div>
        <div class="content">
            <div class="c1" @click="scanCode"><van-icon class="scan-icon" name="scan" />扫码核销</div>
            <div class="c2">
                <van-field v-model="params.verificationCode" style="height: 100%" placeholder="请输入验券码" />
                <div class="certificate-verification" @click="writeOff(2)">验券</div>
            </div>
        </div>

        <div class="icons">
            <div class="iconsItem" v-for="(item, index) in iconsList" :key="index" @click="go(item)">
                <img :src="require(`../images/${item.url}`)" alt="" />
                <div>{{ item.text }}</div>
            </div>
        </div>

        <div class="footer" v-if="isMerchant">
            <div class="f1" @click="go({ go: 'storeAdmin' })">
                <div class="f1Img"><img src="../images/gly.png" alt="" /></div>
                <div class="f1text">
                    <div class="f1Left">商家管理员</div>
                    <div class="f1Right"><van-icon name="arrow" /></div>
                </div>
            </div>
            <div class="f1">
                <div class="f1Img"><img src="../images/join.png" alt="" /></div>
                <div class="f1text" @click="goApply">
                    <div class="f1Left">商家加入信息</div>
                    <div class="f1Right"><van-icon name="arrow" /></div>
                </div>
            </div>
            <div class="f1" @click="go({ go: 'scan-code' })">
                <div class="f1Img"><img src="../images/join.png" alt="" /></div>
                <div class="f1text">
                    <div class="f1Left">核销</div>
                    <div class="f1Right"><van-icon name="arrow" /></div>
                </div>
            </div>
            <div class="f2"></div>
        </div>
        <van-overlay :show="show" @click="closeOverlay" z-index="9999">
            <!-- <div class="wrapper" @click.stop> -->
            <div class="wrapper">
                <div id="reader" class="block"></div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode';
import { selectIsStore } from '../api/index';
import { reqWriteOff } from '../api/merchant';

export default {
    data() {
        return {
            value: '',
            show: false,
            showScan: false,
            isstore: false,
            isMerchant: 1,
            val: '',
            userinfo: {},
            params: {
                phone: '',
                verificationCode: '',
                verificationType: 1 // 1:扫码 2:输入
            },
            imageuHost: 'https://file.pzhszgh.cn',
            iconsList: [
                { text: '账单', url: 'zd.png', go: 'billing-center' },
                { text: '福利券', url: 'flq.png', go: 'flq' },
                { text: '花惠卡折扣', url: 'hhk.png', go: 'hhk' },
                { text: '门店', url: 'md.png', go: 'md' }
            ]
        };
    },
    created() {
        this.$root.$globalData.phone1 = this.$route.query.phone;
        this.params.phone = this.$route.query.phone;
        // this.$root.$globalData.phone1 = '19113485587';
        // this.$root.$globalData.phone1 = '15730551967';
        // this.$root.$globalData.phone1 = '13198566796';
        // this.$root.$globalData.phone1 = '15696695118';
        this.selectIsStore();
    },
    methods: {
        selectIsStore() {
            selectIsStore({ phone: this.$globalData.phone1 }).then(res => {
                console.log(res);
                if (res.data === null || res.data.mallorg.audit !== 2) {
                    this.$router.push({ path: '/store', query: { phone: this.$globalData.phone1 } });
                }
                this.isMerchant = res.data.isMerchant;
                this.userinfo = res.data.mallorg;
                this.imageuHost = this.imageuHost + res.data.mallorg.logo;
            });
        },
        scanCode() {
            this.show = !this.show;
            this.getCameras();
        },
        closeOverlay() {
            this.show = false;
            this.stop();
        },
        writeOff(verificationType) {
            this.params.verificationType = verificationType;
            reqWriteOff(this.params)
                .then(res => {
                    if (res.code === 200) {
                        this.$toast.success('核销成功!');
                    } else {
                        this.$toast.fail(res.data);
                    }
                })
                .catch(() => {
                    this.$toast.fail('服务器出现错误，请稍后再试！');
                });
        },
        getCameras() {
            Html5Qrcode.getCameras()
                .then(devices => {
                    if (devices && devices.length) {
                        this.start(); // 扫码
                    }
                })
                .catch(() => {
                    this.show = false;
                    this.$toast.fail('您需要授予相机访问权限!');
                });
        },
        start() {
            // environment后置 user前置
            this.html5QrCode = new Html5Qrcode('reader');
            this.html5QrCode
                .start(
                    { facingMode: 'environment' },
                    {
                        fps: 1, // 500毫秒扫描一次
                        qrbox: { width: 250, height: 250 }
                    },
                    (decodedText, decodedResult) => {
                        this.params.verificationCode = decodedText;
                        this.params.verificationType = 1;
                        this.writeOff(1);
                        // this.$toast.success(decodedText);
                        this.stop();
                    }
                )
                .catch(err => {
                    console.log(`Unable to start scanning, error: ${err}`);
                });
        },
        stop() {
            this.html5QrCode &&
                this.html5QrCode
                    .stop()
                    .then(ignore => {
                        // QR Code scanning is stopped.
                        console.log('QR Code scanning stopped.');
                    })
                    .catch(() => {
                        // Stop failed, handle it.
                        console.log('Unable to stop scanning.');
                    })
                    .finally(() => {
                        this.show = false;
                    });
        },
        go(e) {
            this.$router.push(`/${e.go}`);
        },
        goApply() {
            this.$router.push({ path: '/Apply', query: { isAdd: false } });
        }
    },
    beforeDestroy() {
        this.stop();
    }
};
</script>

<style lang="scss" scoped>
.orange {
    color: #ff6633;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .block {
        width: 100vw;
        min-height: 300px;
    }
}

.index-box {
    background: #f8f8f8;
    .top {
        display: flex;
        padding: 24px 15px;
        background: #fff;
        .left {
            width: 50px;
            height: 50px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .right {
            padding: 0 10px;
            .r1 {
                font-size: 16px;
                font-weight: 800;
                color: #111111;
            }
            .r2 {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #444444;
            }
            .r3 {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #777777;
            }
        }
    }
    .content {
        background: #fff;
        padding: 25px 38px;
        margin: 10px 0;
        .c1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 300px;
            height: 40px;
            background: #ff6633;
            border-radius: 3px;
            color: #fff;
            font-size: 15px;

            .scan-icon {
                margin-right: 5px;
            }
        }
        .c2 {
            width: 300px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #ff6633;
            border-radius: 3px;
            margin-top: 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;

            .van-field {
                flex: 1;

                ::v-deep .van-field__body {
                    height: 100%;

                    .van-field__control::placeholder {
                        color: #ff6633;
                    }
                }
            }

            .certificate-verification {
                width: 70px;
                height: 100%;
                background-color: #ff6633;
                border-top-right-radius: 3px;
                border-bottom-right-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                color: #ffffff;
            }
        }
    }
    .icons {
        display: flex;
        justify-content: space-between;
        background: #fff;
        // height: 90px;
        padding: 15px 26px;
        margin: 10px 0;
        font-size: 14px;
        .iconsItem {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            // justify-content: center;
            justify-content: space-around;
            height: 80px;
            img {
                width: 41px;
                height: 41px;
            }
        }
    }
    .footer {
        font-size: 16px;
        background-color: #fff;
        img {
            width: 21px;
            height: 21px;
        }
        .f1 {
            display: flex;
            padding: 10px;
            .f1Img {
                margin-right: 10px;
            }
            .f1text {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                border-bottom: 1px solid #f5f5f5;
                padding-bottom: 10px;
            }
        }
    }
}
</style>
